import React from 'react';
import PropTypes from 'prop-types';
import { SdfIcon, SfcShellTopHat } from '@waypoint/react-components';

const SupportBannerNew = ({ onEndSession }) => {
	return (
		<SfcShellTopHat slot="top-hat" className="w-full flex items-center justify-center" data-attr-id="wm-support-banner">
			<div>
				You are logged in as WorkMarket Support, and any actions taken will be logged.
			</div>

			<div
				data-attr-id="wm-support-banner-btn"
				tabIndex="0"
				role="button"
				className="ml-6 text-sm underline cursor-pointer"
				onKeyDown={ onEndSession }
				onClick={ onEndSession }
			>
				<SdfIcon icon="action-logout" className="text-inverse-default mr-2" />
				End session
			</div>
		</SfcShellTopHat>
	);
};

SupportBannerNew.propTypes = {
	onEndSession: PropTypes.func.isRequired,
};


export default SupportBannerNew;